import { useSelector } from "react-redux";
import BaseParagraph from "../../baseComponents/baseParagraph.js";
import DarkWrapper from "./DarkWrapper.js";
import useColors from "../../customHooks/useColors.js";

const SuccessView = () => {
  const successState = useSelector((state) => state.successState);
  const [currentColors] = useColors();

  const styles = {
    innerElement: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: `rgba(0,0,0,0.85)`,
      minWidth: "180px",
      height: "180px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      borderRadius: "10px",
      padding: "20px",
      zIndex: "2000000",
    },
    check: {
      color: currentColors.secondary,
      fontSize: "70px",
      bodred: "1px solid white,",
    },
    successText: {
      color: "rgb(255,255,255)",
      textAlign: "center",
    },
  };

  return (
    <DarkWrapper env="successView">
      <div style={styles.innerElement}>
        <svg className="checkmark" viewBox="0 0 52 52">
          <path
            className="checkmark__check"
            fill="none"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
          />
        </svg>

        <BaseParagraph style={styles.successText}>
          {successState.successMsg}
        </BaseParagraph>
      </div>
    </DarkWrapper>
  );
};

export default SuccessView;
